import React from 'react';
import PropTypes from 'prop-types';
import Generic from './generic';

/**
 * This file provides the results of a Contact Point lookup
 * It will be passed the serviceType prop, which can be used
 * to switch to a different and specific results component
 */
const Results = (props) => <Generic {...props} />;

Results.propTypes = {
  serviceType: PropTypes.string.isRequired,
  additionalAnswerText: PropTypes.object,
};

export default Results;
